import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { Button } from "~/components/ui/button";
import { HOST_ONBOARDING_HREF, NAV_AUTH_HREF } from "~/lib/constants/nav";
import { MobileMenuTrigger } from "./MobileMenuTrigger";

/**
 * The signed-out right-hand side. Doubles as the Suspense fallback for the
 * actions slot: signed-out visitors are the overwhelming majority on public
 * pages, so serving them the real markup in the prerendered shell means the
 * streamed slot resolves to something identical and nothing visibly swaps.
 */
export function SignedOutActions() {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Button asChild={true} variant="ghost" size="sm"><Link href={NAV_AUTH_HREF}>Sign in</Link></Button>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="hidden items-center gap-2 md:flex">{t0}<Button asChild={true} variant="primary" size="md"><Link href={HOST_ONBOARDING_HREF}>List your spot</Link></Button></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Button asChild={true} variant="ghost" size="sm"><Link href={NAV_AUTH_HREF}>Sign in</Link></Button>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <>{t1}<div className="flex items-center gap-2 md:hidden">{t2}<Button asChild={true} variant="primary" size="sm"><Link href={HOST_ONBOARDING_HREF}>List your spot</Link></Button></div><MobileMenuTrigger /></>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}